import { useState } from 'react';
import { Button, Modal, TextField } from '@scale/scaleui';

type AddTurnFeedbackModalProps = {
  onClose: () => void;
  onAddTurn: (turnIndexOrRange: string) => void;
};

export const AddTurnFeedbackModal = ({ onClose, onAddTurn }: AddTurnFeedbackModalProps) => {
  const [newTurnIndex, setNewTurnIndex] = useState<string | null>(null);

  return (
    <div className="flex items-center justify-center">
      <Modal
        open
        className="flex flex-col gap-2"
        innerClassName="max-w-sm"
        onClose={onClose}
        theme="scale-theme"
        title="Add turns feedback"
        actions={
          <div className="flex items-center gap-2 justify-end">
            <Button onClick={onClose} variant="secondary">
              Cancel
            </Button>
            <Button
              disabled={!newTurnIndex}
              onClick={() => {
                if (!newTurnIndex) {
                  return;
                }
                onAddTurn(newTurnIndex);
              }}
            >
              Add turn feedback
            </Button>
          </div>
        }
      >
        <TextField
          id="text-field-turn-index"
          label="Turn index"
          helperText={`Please select the turn number you want to add feedback to, use the turn number which starts at 1. \n You can also add a range like 1-5 which will add turns from 1-5 inclusive.`}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setNewTurnIndex((event.target as HTMLInputElement).value);
          }}
          placeholder="Set a number or a range (like 1-4)"
          type="text"
          value={newTurnIndex ?? ''}
        />
      </Modal>
    </div>
  );
};
